import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTextBold';
/** Renders an SVG icon. */
const SvgTextBold = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 5.5A1.5 1.5 0 0 1 9.5 4H17a6.5 6.5 0 0 1 4.835 10.844A7 7 0 0 1 18.5 28h-9A1.5 1.5 0 0 1 8 26.5zM11 17v8h7.5a4 4 0 0 0 0-8zm0-3h6a3.5 3.5 0 1 0 0-7h-6z"
      />
    </svg>
  );
};
SvgTextBold.displayName = displayName;
export default SvgTextBold;
